import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MessageService } from '../message.service';
import { NotifierService } from 'angular-notifier';
import { RestApiService } from '../rest-api.service';
import { Router } from '@angular/router';
import { Formatters } from 'angular-slickgrid';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-email-attribute-master',
    templateUrl: './email-attribute-master.component.html',
    styleUrls: ['./email-attribute-master.component.css']
})
export class EmailAttrbuteMasterComponent implements OnInit, OnDestroy {

    displayed = true;
    subject: string;
    totalData = 0;
    show: boolean;
    selected: number;
    respObject: any;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;
    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    offset: number;
    // =============================
    psno: string;
    username: string;
    phoneno: string;
    email: string;
    categories = [];
    tickets = [];
    ticketSelected: number;
    categorySelected: string;
    categoryName: string;
    ticket_type: string;
    priorities = [];
    prioritySelected: number;
    priority_name: string;
    categoryArr = [];
    dataLoaded: boolean;
    isShow = false;

    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    categrySelected: any;
    cats: any;
    userName: string;
    showExportBtn = true;
    isExportDisable = false;
    dataExcel = [];
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;
    selectedTypeValue: number;
    AttributrTitle: any;
    AttributrValue: any;
    AttributrName: any;
    ticketTypes = [];

    constructor(private _rest: RestApiService, private messageService: MessageService,
        private route: Router, private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    // console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {

                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            console.log(JSON.stringify(item));

                            if (item.attributes_type === 'uid' || item.attributes_type === 'uidSSC') {
                                this.notifier.notify('error', 'You Are not Allowed To Delete UID. Contact iFIX Admin');
                            } else {
                                this._rest.deleteEmailAttribute({ user_id: this.messageService.getUserId(), id: item.id }).subscribe((res) => {
                                    this.respObject = res;
                                    // console.log(JSON.stringify(this.respObject));
                                    if (this.respObject.success) {
                                        this.messageService.sendAfterDelete(item.id);
                                        this.notifier.notify('success', 'Email Attributes Deleted successfully');
                                    } else {
                                        this.notifier.notify('error', this.respObject.errorMessage);
                                    }
                                }, (err) => {
                                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                                });
                            }
                        }
                    }
                    break;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
    }

    ngOnInit() {
        this.AttributrName = '';
        this.ticketTypes = [];
        this.AttributrValue = '';
        this.AttributrTitle = '';
        this.selectedTypeValue = 0;
        this.isShow = false;
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Email Attributes',
            openModalButton: 'Add Email Attributes',
            searchModalButton: 'Search',
            breadcrumb: 'Email Attributes',
            folderName: 'All Email Attributes',
            tabName: 'Email Attributes',
            exportBtn: 'Export to excel',

        };
        this.psno = '';
        this.username = '';
        this.phoneno = '';
        this.email = '';
        let columnDefinitions = [];
        columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {
                id: 'attributes_type', name: 'Attribute Type', field: 'attributes_type', sortable: true, filterable: true
            },
            {
                id: 'attributes_name', name: 'Attribute Name', field: 'attributes_name', sortable: true, filterable: true
            },
            {
                id: 'attributes_value', name: 'Attribute Value', field: 'attributes_value', sortable: true, filterable: true,
                cssClass: 'highlight'
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        if (this.clientId === 2) {
            this.isShow = true;
        }
        this.selectedTypeValue = 0;
        this.AttributrName = '';
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Ticket Type' });
                this.tickets = this.respObject.details;
                this.ticketSelected = 0;
                this.getPriority();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();
    }

    baseCategories: any;
    onTicketChange(selectedIndex: any) {
        this._rest.getTicketCreateLoadingDtls(this.messageService.getUserId(), this.ticketSelected, this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.baseCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
                this.ticketTypes = this.respObject.details[0].attribute;
            } else {
                this.errorMessage = this.respObject.errorMessage;
            }
        });
    }

    cat = [];

    onCategoryChangeDropDown(ticket, option) {
        const opt = JSON.parse(option);
        console.log('opt ==>  ' + JSON.stringify(opt));
        if (opt.type !== 'header') {
            const value = opt.id;
            let matched = false;
            const index = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id + 1);
            console.log('index:' + index);
            const index1 = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id);
            const pid = this.ticketTypes[index1].options[0].id;

            console.log('this.cat ==> ' + JSON.stringify(this.cat))

            if (this.cat.length === 0) {
                this.cat.push({ pid: pid, cid: value });
            } else {
                for (let i = 0; i < this.cat.length; i++) {
                    if (this.cat[i].pid === pid) {
                        matched = true;
                        this.cat[i].cid = value;
                        break;
                    }
                }
                if (!matched) {
                    this.cat.push({ pid: pid, cid: value });
                } else {
                    for (let i = index; i < this.cat.length; i++) {

                        if (index > -1) {
                            this.cat[i].cid = 0;
                        }
                    }
                }
            }

            if (index > -1) {
                // console.log('index:' + index);
                for (let i = index + 1; i < this.ticketTypes.length; i++) {
                    const options = this.ticketTypes[i].options;
                    // console.log(JSON.stringify(options));
                    for (let j = 0; j < options.length; j++) {
                        if (options[j].type) {
                            // options=[];
                            this.ticketTypes[i].options = [options[j]];
                            break;
                        }
                    }
                }
            }
            let data;
            if (index > -1) {
                data = this.ticketTypes[index].options[0];
                this.ticketTypes[index].options = [];
                this.dataLoaded = false;
            }
            this._rest.getAttributesParentWise(this.clientId, opt.id).subscribe((res) => {
                this.respObject = res;

                if (this.respObject.success) {
                    this.dataLoaded = true;
                    if (this.respObject.details) {
                        let resobj = [];

                        for (let i = 0; i < this.respObject.details.length; i++) {
                            resobj.push({ id: this.respObject.details[i].id, title: this.respObject.details[i].title });
                        }

                        resobj.unshift(data);
                        console.log(' --- Data VALUE == >> ' + JSON.stringify(data));

                        console.log(index + ' --- NEEXT CAT DROPDOWN VALUE == >> ' + JSON.stringify(resobj));
                        this.ticketTypes[index].options = resobj;
                    }

                } else {
                    this.dataLoaded = true;
                    if (index > -1) {
                        this.ticketTypes[index].options = [data];
                    }
                    // this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
    }


    onChnageSenderType() {
        console.log('selectedTypeValue == >> ' + this.selectedTypeValue);
        if (this.selectedTypeValue === 2) {
            this.AttributrTitle = 'cat_mapping';
            this.AttributrValue = '';
            this.AttributrName = '';
        } else {
            this.AttributrValue = '';
            this.AttributrTitle = '';
            this.AttributrName = '';
        }
    }

    getPriority() {
        this._rest.getBusinessPriorityTicketTypeWise(this.clientId, this.ticketSelected).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Priorities' });
                this.priorities = this.respObject.details;
                this.prioritySelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    exportToExcel() {

    }

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.AttributrValue = '';
            this.AttributrTitle = '';
            this.AttributrName = '';
            this.selectedTypeValue = 1;
            this.modalService.open(content).result.then((result) => {
            }, (reason) => {

            });
        }

    }

    searchModal() {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.psno = '';
            this.username = '';
            this.phoneno = '';
            this.email = '';
            // this.modalService.open(scarch_content).result.then((result) => {
            // }, (reason) => {

            // });
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });

        }

    }

    search() {
        this._rest.searchAllFollowUp(this.categrySelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.cats = this.respObject.details;
                this.messageService.setGridData(this.cats);
                this.messageService.setTotalData(this.cats.length);
                this.searchModalReference.close();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    save() {
        let cats = '';
        let catsval = '';
        if (this.cat.length === this.ticketTypes.length) {
            for (let i = 0; i < this.cat.length; i++) {
                if (this.cat[i].cid !== 0) {
                    cats += this.cat[i].pid + '#' + this.cat[i].cid;
                    catsval += this.cat[i].cid;
                    if (i !== this.cat.length - 1) {
                        cats += ',';
                        catsval += ',';
                    }

                    if (i == this.cat.length - 1) {
                        this.AttributrValue = cats;
                    }

                } else {
                    this.notifier.notify('error', 'Please Select the Categories..........');
                    break;
                }
            }
        } else {
            this.notifier.notify('error', 'Please Select the Categories..........');
        }


        console.log('selectedTypeValue == >> ' + this.selectedTypeValue + ', AttributrTitle ==> '
            + this.AttributrTitle + ', AttributrValue == >> ' + this.AttributrValue + ', \ncats == >> ' + cats);



        const data = {
            user_id: this.messageService.getUserId(),
            attributes_type: this.AttributrTitle,
            attributes_value: this.AttributrValue,
            client_id: this.clientId
        };

        console.log('DATA === >>> ' + JSON.stringify(data) + ", IS Blank == > " + this.messageService.isBlankField(data));

        if (!this.messageService.isBlankField(data)) {

            if (this.selectedTypeValue === 2) {
                data['attributes_additional_value'] = catsval;
                data['attributes_name'] = this.AttributrName;
            }

            this._rest.AddEmailAttr(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.notifier.notify('success', 'Email Attributes Added successfully');
                    this.messageService.setRow({
                        id: this.respObject.details.insertId,
                        attributes_type: this.AttributrTitle,
                        attributes_value: this.AttributrValue
                    });
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        } else {
            this.notifier.notify('error', this.messageService.BLANK_ERROR_MESSAGE);
        }


    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
        }

    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getEmailAttrMaster(offset, this.pageSize, paginationType, this.clientId).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
    }


    onPriorityChange(selectedIndex: any) {
        this.priority_name = this.priorities[selectedIndex].name;
    }



    getCategory() {
        this._rest.getCategoryByTicketTypeNDynamicLevel(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                // console.log(this.respObject);
                this.respObject.details.unshift({ id: 0, name: 'Select Category' }, { id: -1, name: 'Select All' });
                this.categories = this.respObject.details;
                for (let i = 2; i < this.categories.length; i++) {
                    this.categoryArr.push(this.categories[i].id);
                }
                this.categorySelected = '0';
            } else {
                this.categories = [];
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

}
